
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabandbusservicepunenagpur() {



    const cardData =
    {
        keyword: 'Corporate Cabs and Bus Services in Nagpur',
        heading: 'etravo : Corporate Cabs and Bus Services in Nagpur ',
        headingDescription: 'eTravo provides reliable Corporate Cab and Bus Services in Nagpur, tailored for businesses, industrial parks, and IT hubs across the city. Whether your organization requires executive cabs for meetings, airport transfers, and client visits or well-equipped buses for daily employee transport and corporate events, our services deliver punctuality, comfort, and professionalism. With GPS-enabled vehicles, trained chauffeurs, and a focus on operational efficiency, eTravo ensures seamless corporate mobility across Nagpur’s growing business landscape.',

        top: 'Top Places to Visit in Nagpur with etravo',
        "topPlaces": [
    {
      "title": "Deekshabhoomi",
      "description": "A sacred monument of Navayana Buddhism, Deekshabhoomi is where Dr. B.R. Ambedkar embraced Buddhism in 1956. The site features a large stupa and serves as a pilgrimage center, especially during Dhamma Chakra Pravartan Din."
    },
    {
      "title": "Sitabuldi Fort",
      "description": "Built by the British after the Battle of Sitabuldi in 1817, this historic fort stands atop a hillock in central Nagpur. It is open to the public on select national holidays and offers panoramic views of the city."
    },
    {
      "title": "Futala Lake",
      "description": "Constructed by the Bhosle kings, Futala Lake spans 60 acres and is known for its scenic beauty, especially in the evenings when illuminated. The lake is surrounded by forests on three sides and a landscaped beach on the fourth."
    },
    {
      "title": "Ambazari Lake and Garden",
      "description": "The largest lake in Nagpur, Ambazari Lake was built in 1870 and is surrounded by a garden established in 1958. The area is popular for morning walks and offers a serene environment amidst mango trees."
    },
    {
      "title": "Raman Science Centre",
      "description": "An interactive science museum affiliated with Mumbai's Nehru Science Centre, it features exhibits on science and technology, a planetarium, and various educational programs aimed at promoting scientific awareness."
    },
    {
      "title": "Dragon Palace Buddhist Temple",
      "description": "Located in Kamptee, this Indo-Japanese temple is known for its unique architecture and tranquil ambiance. It serves as a center for Buddhist learning and meditation."
    },
    {
      "title": "Balasaheb Thackeray Gorewada International Zoological Park",
      "description": "Spread over 1,914 hectares, this zoological park aims to be one of India's largest captive zoo safaris. It offers opportunities to observe various wildlife species in a naturalistic setting."
    },
    {
      "title": "Ramtek Fort Temple",
      "description": "Situated about 40 km from Nagpur, this temple is believed to be the place where Lord Rama rested during his exile. The fort offers historical insights and panoramic views of the surrounding area."
    },
    {
      "title": "Swaminarayan Temple",
      "description": "A beautifully constructed temple dedicated to Lord Swaminarayan, featuring intricate carvings and a peaceful environment suitable for spiritual reflection."
    },
    {
      "title": "Zero Mile Stone",
      "description": "Erected by the British during the Great Trigonometrical Survey of India, this monument marks the geographical center of colonial India and is a significant historical landmark in Nagpur."
    }
  ],
   "services": [
    {
      "name": "Corporate Travel Solutions in Nagpur",
      "description": "eTravo offers end-to-end corporate travel solutions in Nagpur, designed to streamline your business transportation needs. From daily employee commutes to business event travel, our services ensure punctuality, safety, and comfort with a modern fleet and professional drivers, tailored to support your company’s operations seamlessly."
    },
    {
      "name": "Executive Cab Hire in Nagpur",
      "description": "Travel in style and comfort with eTravo’s executive cab hire services in Nagpur. Our premium vehicles and experienced chauffeurs provide reliable transportation for corporate executives, ensuring timely arrivals at meetings, airport transfers, and other business engagements with top-notch service and professionalism."
    },
    {
      "name": "Employee Transportation Services Nagpur",
      "description": "Simplify your workforce transportation with eTravo’s employee transportation services in Nagpur. We provide scheduled bus and cab services covering key residential and commercial areas, ensuring safe, timely, and efficient daily commutes that enhance employee satisfaction and reduce absenteeism."
    },
    {
      "name": "Bus & Cab Rentals for Office Staff in Nagpur",
      "description": "eTravo offers flexible bus and cab rental options for office staff in Nagpur. Whether you require short-term rentals for projects or long-term contracts for daily commutes, our well-maintained vehicles and professional drivers guarantee reliable service that fits your business needs."
    },
    {
      "name": "Staff Commute Bus Services in Nagpur",
      "description": "Our staff commute bus services in Nagpur are tailored to meet the demands of corporate schedules. We ensure efficient routing and timely pickups and drops, helping companies maintain smooth operations and ensuring employees reach their workplace comfortably and on time."
    },
    {
      "name": "Budget Corporate Transport Nagpur",
      "description": "eTravo provides budget-friendly corporate transport solutions in Nagpur without compromising on quality or reliability. Our cost-effective options help businesses manage transportation expenses while maintaining high standards of service, safety, and comfort for their employees."
    },
    {
      "name": "Business Event Bus Rentals Nagpur",
      "description": "For corporate events in Nagpur, eTravo offers specialized bus rental services that cater to group transportation needs. Whether it’s a conference, seminar, or team outing, our spacious and comfortable buses ensure your guests and staff travel together conveniently and punctually."
    }
  ],
  "tableData": [
    ["Corporate Travel Solutions in Nagpur", "Executive Cab Hire in Nagpur"],
    ["Employee Transportation Services Nagpur", "Bus & Cab Rentals for Office Staff in Nagpur"],
    ["Staff Commute Bus Services in Nagpur", "Budget Corporate Transport Nagpur"],
    ["Business Event Bus Rentals Nagpur", ""]
  ],






"whychoose": [
    {
        "WhyChooseheading": "Comprehensive Corporate Transport Services in Nagpur",
        "WhyChoosedescription": "Nagpur’s growing industrial base, IT sector, and central location make it a key city for business operations—and eTravo is here to power your corporate mobility. From employee transportation to VIP movement, our cab and bus services are designed to be timely, reliable, and business-ready."
    },
    {
        "WhyChooseheading": "Diverse Fleet to Suit Every Business Need",
        "WhyChoosedescription": "Our fleet in Nagpur includes well-maintained hatchbacks, sedans, SUVs, tempo travellers, and large AC buses. Whether you need daily office commutes, client pick-ups, or logistics support for events, we have the right vehicle to match your operational and comfort requirements."
    },
    {
        "WhyChooseheading": "Timely and Shift-Compatible Transport",
        "WhyChoosedescription": "Many businesses in Nagpur, including BPOs, industrial parks, and logistics firms, operate in shifts. eTravo offers round-the-clock cab and bus services with flexible scheduling to accommodate morning, evening, and night shifts—ensuring zero downtime or transport delays."
    },
    {
        "WhyChooseheading": "Experienced, Verified Drivers with Route Familiarity",
        "WhyChoosedescription": "Our professional drivers are background-verified, uniformed, and well-versed with Nagpur’s key areas such as MIHAN, Butibori MIDC, and IT hubs. Their experience ensures safe, courteous service while reducing travel time through optimal route planning."
    },
    {
        "WhyChooseheading": "Transparent Corporate Pricing and Billing",
        "WhyChoosedescription": "eTravo offers clear, upfront pricing without any hidden fees. Our billing process includes GST-compliant invoices, monthly consolidated statements, and custom packages for companies of all sizes—making it easy for your finance and admin teams to manage costs."
    },
    {
        "WhyChooseheading": "Safety and Hygiene are Always a Priority",
        "WhyChoosedescription": "All vehicles undergo regular cleaning and are equipped with safety features such as seat belts, GPS tracking, first aid kits, and fire extinguishers. eTravo ensures that your employees and guests enjoy a secure, clean, and comfortable commute every time."
    },
    {
        "WhyChooseheading": "Real-Time Monitoring and 24/7 Support",
        "WhyChoosedescription": "Track every ride in real time and access round-the-clock customer support for scheduling, route adjustments, or urgent requests. Our dedicated operations team ensures seamless coordination with your HR or admin teams to maintain high service reliability."
    },
    {
        "WhyChooseheading": "Tailored Transport Packages for Nagpur Businesses",
        "WhyChoosedescription": "Whether you’re a manufacturing unit in Butibori, a corporate office in Civil Lines, or an IT startup in MIHAN, eTravo designs custom transport solutions to fit your exact needs. From long-term employee shuttles to short-term event logistics, we offer scalable services that grow with your business."
    }
]





































    }

// Corporate Cabs and Bus Services in Nagpur – eTravo

const faqData = [
    [
        {
            question: 'What corporate travel services does eTravo offer in Nagpur?',
            answer: 'eTravo offers reliable cab and bus services in Nagpur for corporate clients, including employee transport, executive travel, team transfers, and outstation business travel across Maharashtra.',
        },
        {
            question: 'Can eTravo support employee transport for IT parks and industrial zones in Nagpur?',
            answer: 'Yes, we provide structured employee transport for both tech parks and industrial areas in Nagpur, with support for multiple shifts, optimized routing, and fleet tracking.',
        },
        {
            question: 'What vehicle options are available for corporate use in Nagpur?',
            answer: 'Our fleet includes hatchbacks, sedans, SUVs, tempo travellers, and AC buses (13–50 seaters), all designed for comfort, punctuality, and compliance with safety standards.',
        },
        {
            question: 'Are GPS tracking and safety measures included in the service?',
            answer: 'Absolutely. All vehicles are GPS-tracked in real time, and we offer driver verification, digital logs, and route compliance reports to ensure a secure corporate transport experience.',
        },
        {
            question: 'Can we book cabs or buses for corporate events and business meetings?',
            answer: 'Yes, eTravo provides flexible cab and bus rentals for conferences, seminars, audits, and client visits — including pickup coordination, waiting time, and multi-point routing if needed.',
        },
        {
            question: 'Do we get dedicated account support in Nagpur?',
            answer: 'Yes, every corporate client is assigned a dedicated account manager to handle scheduling, operations, issue resolution, and regular performance reviews.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Sandeep Borkar',
        designation: 'Admin Manager, BrightCore Technologies',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo made our employee commute in Nagpur hassle-free. Their buses are punctual, and the team is highly professional. Excellent for corporate use.”',
    },
    {
        name: 'Ms. Richa Agrawal',
        designation: 'HR Executive, IndraMek Industries',
        rating: [1, 1, 1, 1, 1],
        text: '“We’ve been using eTravo’s services for both cabs and buses. The experience has been smooth, and their real-time tracking gives us peace of mind. Highly recommended in Nagpur.”',
    },
];













    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cabs and Bus Services in Nagpur",
  "image": "https://www.etravo.in/images/keyword/corporate-cabs-bus-nagpur.jpg",
  "description": "Efficient corporate cab and bus services in Nagpur by eTravo. Ideal for executive cab hire, employee transportation, staff commute, and business event bus rentals with affordable and reliable corporate transport solutions.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cabs-and-bus-services-in-nagpur"
  }
};





    return (
        <div>

<Helmet>
  <title>Corporate Cabs and Bus Services in Nagpur | Executive Hire & Employee Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus services in Nagpur with eTravo for executive hire, employee transport, and business event rentals. Affordable and reliable corporate travel solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/23.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabandbusservicepunenagpur;